var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRing({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5 5.2L2.5 1.56L3.5 0H6.5L7.5 1.56L5 5.2ZM7.1875 3.12L6.4375 4.225C7.8125 4.81 8.75 6.175 8.75 7.8C8.75 8.83434 8.35491 9.82632 7.65165 10.5577C6.94839 11.2891 5.99456 11.7 5 11.7C4.00544 11.7 3.05161 11.2891 2.34835 10.5577C1.64509 9.82632 1.25 8.83434 1.25 7.8C1.25 6.175 2.1875 4.81 3.5625 4.225L2.8125 3.12C1.125 3.965 0 5.72 0 7.8C0 9.17913 0.526784 10.5018 1.46447 11.477C2.40215 12.4521 3.67392 13 5 13C6.32608 13 7.59785 12.4521 8.53553 11.477C9.47322 10.5018 10 9.17913 10 7.8C10 5.72 8.875 3.965 7.1875 3.12Z",
    fill: "#424444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing);
export default __webpack_public_path__ + "static/media/ring.bf48b456b508b22fb36288b3a45c6946.svg";
export { ForwardRef as ReactComponent };